var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "stoffe-image-gallery",
      attrs: { itemscope: "", itemtype: "https://schema.org/Thing" },
    },
    [
      _vm.showThumbs && _vm.carouselImages.length > 1
        ? _c("div", { staticClass: "stoffe-gallery__thumbnails" }, [
            _c(
              "button",
              {
                staticClass: "stoffe-gallery__nav stoffe-gallery__nav--up",
                attrs: { disabled: _vm.thumbScrollPos <= 0 },
                on: {
                  click: function ($event) {
                    return _vm.scrollThumbs("up")
                  },
                },
              },
              [_c("i", { staticClass: "fa fa-chevron-up" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "thumbContainer",
                staticClass: "stoffe-gallery__thumb-container",
              },
              _vm._l(_vm.carouselImages, function (imagePreview, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "stoffe-gallery__thumb",
                    class: {
                      "stoffe-gallery__thumb--active":
                        _vm.currentItem === index,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goTo(index)
                      },
                    },
                  },
                  [
                    _c("lazy-img", {
                      attrs: {
                        alt: _vm.getAltText(imagePreview),
                        "image-url": imagePreview.url,
                        title: _vm.getImageName(imagePreview),
                        width: _vm.getImageWidth(imagePreview),
                        height: _vm.getImageHeight(imagePreview),
                        "picture-class": "stoffe-gallery__thumb-img",
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "stoffe-gallery__nav stoffe-gallery__nav--down",
                attrs: { disabled: _vm.thumbScrollPos >= _vm.maxThumbScroll },
                on: {
                  click: function ($event) {
                    return _vm.scrollThumbs("down")
                  },
                },
              },
              [_c("i", { staticClass: "fa fa-chevron-down" })]
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "stoffe-gallery__main" },
        [
          _c("add-to-wish-list", {
            attrs: {
              "variation-id": _vm.currentVariation.variation.id,
              "show-text": false,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "single",
              staticClass:
                "single-carousel owl-carousel owl-theme owl-single-item",
            },
            _vm._l(_vm.singleImages, function (image, index) {
              return _c("div", { key: index, staticClass: "prop-1-1" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href: image.url,
                      "data-lightbox": `single-item-image${_vm._uid}`,
                    },
                  },
                  [
                    _vm.shouldLoadImage(index)
                      ? _c("lazy-img", {
                          attrs: {
                            alt: _vm.getAltText(image),
                            "image-url": image.url,
                            title: _vm.getImageName(image),
                            width: _vm.getImageWidth(image),
                            height: _vm.getImageHeight(image),
                          },
                        })
                      : _c("div", {
                          staticClass: "stoffe-gallery__placeholder",
                          style: {
                            width: _vm.getImageWidth(image) + "px",
                            height: _vm.getImageHeight(image) + "px",
                          },
                        }),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          !_vm.initialized && _vm.singleImages.length
            ? _c(
                "div",
                {
                  staticClass:
                    "single-carousel owl-carousel owl-loaded owl-theme owl-single-item",
                },
                [
                  _c(
                    "div",
                    { staticClass: "prop-1-1" },
                    [
                      _c("lazy-img", {
                        attrs: {
                          alt: _vm.getAltText(_vm.singleImages[0]),
                          "image-url": _vm.singleImages[0].url,
                          title: _vm.getImageName(_vm.singleImages[0]),
                          width: _vm.getImageWidth(_vm.singleImages[0]),
                          height: _vm.getImageHeight(_vm.singleImages[0]),
                          "picture-class": "owl-placeholder",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }